import {
  openReviewShortOffcanvas,
  closeReviewShortOffcanvas,
  moveToNextClosetItemReview,
} from "@actions/review-short-actions";
import { useDispatch, useSelector } from "react-redux";

export function useReviewShortOffcanvasOpened() {
  return useSelector((state) => state.reviewShort.open);
}

export function useReviewShortCloset() {
  return useSelector((state) => state.reviewShort.closet);
}

export function useReviewShortFinished() {
  return useSelector((state) => state.reviewShort.finished);
}

export function useClosetItemsToShortReview() {
  const closet = useReviewShortCloset();

  return closet.closet_items?.filter(
    (closetItem) =>
      !closetItem.review?.short_review_done && closetItem.product.family !== "accessory",
  );
}

export function useClosetItemInShortReview() {
  const closetItemsToShortReview = useClosetItemsToShortReview();

  return closetItemsToShortReview?.length > 0 ? closetItemsToShortReview[0] : null;
}

export function useOpenReviewShortOffcanvas() {
  const dispatch = useDispatch();

  return (closet) => dispatch(openReviewShortOffcanvas(closet));
}

export function useCloseReviewShortOffcanvas() {
  const dispatch = useDispatch();

  return () => dispatch(closeReviewShortOffcanvas());
}

export function useMoveToNextClosetItemReview() {
  const dispatch = useDispatch();
  const closetItemInShortReview = useClosetItemInShortReview();

  return () => dispatch(moveToNextClosetItemReview(closetItemInShortReview));
}
